<template>
  <div class="animated fadeIn">
    <basic-heading title="Find Prep Schedule">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <div class="py-2"></div>
    <b-row class="my-4">
      <b-col cols="9">
        <datepicker
          :value="schedule_date"
          @selected="
            (val) => {
              schedule_date = val;
            }
          "
          input-class="form-control font-2xl"
        />
      </b-col>
      <b-col cols="3">
        <b-button
          size="lg"
          block
          variant="primary"
          @click="findSchedule()"
          :disabled="finding"
          >Find</b-button
        >
      </b-col>
    </b-row>

    <div v-if="prep_schedules && prep_schedules.models.length">
      <b-row class="mb-3">
        <b-col
          cols="12"
          class="mb-2"
          v-for="(prep_schedule, index) in prep_schedules.models"
          :key="index"
        >
          <b-button
            size="lg"
            block
            variant="light"
            :to="`/prep-schedules/${prep_schedule.id}/manage`"
          >
            <b-badge
              pill
              v-if="
                prep_schedule.current_schedule_status_log.schedule_status
                  .status == 'Approved'
              "
              variant="success"
            >
              Posted -
              {{
                prep_schedule.current_schedule_status_log.created_at
                  | moment("LL")
              }}
              -
              {{ prep_schedule.current_schedule_status_log.user.name }}
            </b-badge>
            <b-badge
              pill
              v-if="
                prep_schedule.current_schedule_status_log.schedule_status
                  .status == 'Draft'
              "
              variant="warning"
            >
              Draft -
              {{
                prep_schedule.current_schedule_status_log.created_at
                  | moment("LL")
              }}
              -
              {{ prep_schedule.current_schedule_status_log.user.name }}
            </b-badge>
            <span class="pl-3">
              {{ prep_schedule.scheduled_for | moment("LL") }} -
              {{ prep_schedule.user.name }}
            </span>
          </b-button>
        </b-col>
      </b-row>
    </div>

    <div class="clearfix">
      <b-button
        class="float-right"
        size="lg"
        variant="success"
        @click="createNew"
        :disabled="schedule_date === null"
        >New</b-button
      >
    </div>
  </div>
</template>

<script>
import BasicHeading from "../../../components/shared/BasicHeading";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import ScheduleModel from "../../../models/lab/ScheduleModel";

export default {
  name: "PrepWorkflowIndex",
  components: {
    BasicHeading,
    Datepicker,
  },
  data() {
    return {
      schedule_date: null,
      finding: false,
      prep_schedules: null,
    };
  },
  computed: {
    /**
     * Header button configuration
     */
    button_config() {
      return {};
    },
  },
  methods: {
    findSchedule() {
      this.finding = true;
      this.prep_schedules = new S();
      // this.prep_schedules = {};
      // this.prep_schedules.models = [];
      // this.prep_schedules.models.push({
      //   id: this.$uuid.v1(),
      //   scheduled_for: moment().format('YYYY-MM-DD') + ' 00:00:00',
      //   current_schedule_status_log: {
      //     schedule_status: {
      //       status: 'Posted'
      //     },
      //     user: {
      //       name: 'Max Koshney'
      //     },
      //     created_at: moment().format('YYYY-MM-DD HH:mm:ss')
      //   },
      //   user: {
      //     name: 'Kolby Wittmack'
      //   },
      // });
      // this.prep_schedules.models.push({
      //   id: this.$uuid.v1(),
      //   scheduled_for: moment().format('YYYY-MM-DD') + ' 00:00:00',
      //   current_schedule_status_log: {
      //     schedule_status: {
      //       status: 'Draft'
      //     },
      //     user: {
      //       name: 'Max Koshney'
      //     },
      //     created_at: moment().format('YYYY-MM-DD HH:mm:ss')
      //   },
      //   user: {
      //     name: 'Max Koshney'
      //   },
      // });
    },
    createNew() {
      let schedule = new ScheduleModel({
        laboratory_id: this.$store.getters.getLaboratoryContext.id,
        date: moment(this.schedule_date).format("YYYY-MM-DD HH:mm:ss"),
      });
      schedule.save().then(() => {
        this.$router.push("/prep-schedules/" + schedule.id + "/manage");
      });
    },
  },
};
</script>
